export default __webpack_public_path__ + "static/media/i6.37207d46.png";